import React from 'react';
import { IconCalendarMonth, IconClock } from '@tabler/icons-react';

import { useTranslate } from '@src/core/hooks';

import { RescheduleNoticeBox, RescheduleNoticeLine, RescheduleNoticeText } from '../styles';

export type RescheduleAvailabilityBoxProps = {
  /** Null when the seller does not cap reschedules, which hides the line. */
  remainingCount: number | null;
  deadlineLabel: string;
};

export const RescheduleAvailabilityBox = (props: RescheduleAvailabilityBoxProps) => {
  const { remainingCount, deadlineLabel } = props;
  const { i18nElement } = useTranslate();

  return (
    <RescheduleNoticeBox data-testid='reschedule-availability'>
      {remainingCount !== null ? (
        <RescheduleNoticeLine>
          <IconCalendarMonth size={20} aria-hidden />
          <RescheduleNoticeText>
            {i18nElement('checkout_confirmed_reschedule_available', { count: remainingCount })}
          </RescheduleNoticeText>
        </RescheduleNoticeLine>
      ) : null}

      <RescheduleNoticeLine>
        <IconClock size={20} aria-hidden />
        <RescheduleNoticeText>
          {i18nElement('checkout_confirmed_reschedule_deadline', { deadline: deadlineLabel })}
        </RescheduleNoticeText>
      </RescheduleNoticeLine>
    </RescheduleNoticeBox>
  );
};

export default RescheduleAvailabilityBox;
